import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
//import moment from 'moment';

import AdvDashboardBody from './AdvDashboardBody';


class AdviserDashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            advisers: [],
            adviserSelected: null,
            advisersFilter: []
        }
    }

    static getDerivedStateFromProps(props, state) {
        let advisers = [];
        let adviser1 = {};
        let adviserSelected = null;

        const adviserGroup = {
            label: props.advisers[0].groupName,
            value: -1
        }
        advisers.push(adviserGroup)
        props.advisers.map(adviser => {
            adviser1 = {
                label: adviser.adviserName,
                value: adviser.adviserId
            }
            advisers.push(adviser1)
        })

        adviserSelected = !props.selectedAdviserId || props.selectedAdviserId === -1? advisers[0] : 
            advisers.filter(adviser => adviser.value === props.selectedAdviserId).map(adviser => adviser)[0]

        if (!state.adviserSelected)
            return {
                advisers: props.advisers,
                advisersFilter: advisers,
                adviserSelected: adviserSelected
            }
        else
            return {
                advisers: props.advisers.filter(adviser => adviser.adviserId === state.adviserSelected.value).map(adviser => adviser),
            }
    }

    componentDidMount() {
        this.props.setSelectedAdviserId(this.state.adviserSelected.value)
        // if (!this.state.adviserSelected || (this.state.adviserSelected && this.state.adviserSelected.value === -1)) {
        //     // this.props.setSelectedAdviserId(this.state.adviserSelected.value)
        //     this.props.setSelectedAdviserId(!this.props.selectedAdviserId || this.props.selectedAdviserId === " " ?
        //         !this.props.id ? -1 : this.props.id : this.props.selectedAdviserId)
        // }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.adviserSelected && prevState.adviserSelected !== this.state.adviserSelected) {
            const adviser = this._filterAdvisers(this.state.adviserSelected.value);
            this.setState({
                advisers: adviser && adviser,
            })
            this.props.setSelectedAdviserId(this.state.adviserSelected.value)
            this.props.startLoadingMembers(this.state.adviserSelected.value)
            this.setState({ loading: false })

        }
    }

    _filterAdvisers(selectedAdviser) {
        const adviser = this.state.advisers.filter(adviser => adviser.value === selectedAdviser).map(adviser => adviser)
        return adviser
    }

    _onSelect(e) {
        this.setState({ adviserSelected: e})
    }

    render() {
        // const { t } = this.props;
        //const lastLoginDate = moment(new Date(this.props.lastLoginDate)).format("HH:MM A dddd, DD MMMM YYYY")
        const commissionPayments = this.state.adviserSelected && this.state.adviserSelected.value === -1 ?
            this.props.fees.map(fee => fee.commission) : this.state.advisers.map(adviser => adviser.commission)
        const today = new Date();
        const options = { 
            day: 'numeric', 
            month: 'long', 
            year: 'numeric' 
          };

        //   // Display last updated date as the second day of every month
        //   if (today.getDate() < 2){
        //         if (today.getMonth() == 0){
        //             today.setFullYear(today.getFullYear() -1, 11, 2)
        //         } else {
        //             today.setFullYear(today.getFullYear(), today.getMonth()-1, 2)
        //         }
        //   } else {
        //     today.setFullYear(today.getFullYear(), today.getMonth(), 2)
        //   }
      
          // Format the date using the options
        const formattedDate = today.toLocaleDateString('en-US', options);

        return (
            // Code for new UI - start
            <div>
                {/* <div style={{display: "inline-block", float:"right"}}>
                                    You last logged on at {lastLoginDate}
                                </div>
                                <div style={{display: "inline-block"}}>
                                {
                                this.props.groupLogin && 
                                    <Dropdown className="adviserFilter" controlClassName="dropdown-box" 
                                    menuClassName="dropdown-contents" 
                                    arrowClassName="dropdown-arrow"
                                    placeholder="" 
                                    options={this.state.advisersFilter} 
                                    value={this.state.adviserSelected} 
                                    onChange={e => this._onSelect(e)} 
                                    arrowOpen={true}></Dropdown>
                            }
                </div> */}
                <div className="adviserMenu" style={{ backgroundColor: "rgb(186,191,206)" }}>
                    <table className="adviserDashboard">
                        <tbody>
                            <tr style={!this.props.groupLogin ? { display: "none" } : { display: "contents" }}>
                                <td style={{ border: "none", 
                                    display: String(this.props.history.location.pathname).includes("adv/login") ? "contents" : "none"}}>
                                    {/* <div style={{display: "inline-block", float:"right"}}>
                                    You last logged on at {lastLoginDate}
                                </div> */}
                                    <div style={{ display: "inline-block", paddingLeft: "10px" }}>
                                        {
                                            this.props.groupLogin &&
                                            <Dropdown className="adviserFilter" controlClassName="dropdown-box"
                                                menuClassName="dropdown-contents"
                                                arrowClassName="dropdown-arrow"
                                                placeholder=""
                                                options={this.state.advisersFilter}
                                                value={this.state.adviserSelected}
                                                onChange={e => this._onSelect(e)}
                                                arrowOpen={true}></Dropdown>
                                        }
                                    </div>
                                </td>
                                {String(this.props.history.location.pathname).includes("adv/login")?<td><p style={{textAlign:"right", marginRight: "16px"}}>Last updated date: {formattedDate}</p></td>:<></>}
                            </tr>
                            {!String(this.props.history.location.pathname).includes("adv/login")?<tr><td style={{ padding: "none !important" }} colspan="2"><p style={{textAlign:"right", marginRight: "16px"}}>Last updated date: {formattedDate}</p></td></tr>:<></>}
                            <tr style={{ padding: "none !important" }}>
                                <td style={{ padding: "none !important" }} colspan="2">
                                    <AdvDashboardBody {...this.props}
                                        advisers={this.state.adviserSelected && this.state.adviserSelected.value === -1 ?
                                            this.props.advisers : this.state.advisers}
                                        total={(this.state.adviserSelected === null || this.state.adviserSelected.value === -1) && this.props.total}
                                        commissionPayments={commissionPayments}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>

            // Code for new UI - end
            //Existing Code - start
            // <div className="adviserMenu">
            //     <table className="adviserMenu">
            //         <tbody>
            // <tr>
            // <td style={{border: "none", float: "right"}}>
            // {
            //     this.props.groupLogin && 
            //         <Dropdown className="adviserFilter" controlClassName="dropdown-box" 
            //         menuClassName="dropdown-contents" 
            //         arrowClassName="dropdown-arrow"
            //         placeholder="" 
            //         options={this.state.advisersFilter} 
            //         value={this.state.adviserSelected} 
            //         onChange={e => this._onSelect(e)} 
            //         arrowOpen={true}></Dropdown>
            // }
            // </td>
            // <td className="lastLogin">
            //     You last logged on at {lastLoginDate}
            // </td>
            // </tr>
            //             <tr style={{backgroundColor: "#FFFFFF"}}>
            //                 <td>
            //                     <AdvDashboardBody 
            //                         advisers = {this.state.adviserSelected && this.state.adviserSelected.value === -1 ? 
            //                             this.props.advisers : this.state.advisers} 
            //                         total= {(this.state.adviserSelected === null || this.state.adviserSelected.value === -1) && this.props.total}
            //                     />
            //                 </td>
            //                 <td className="charts" style={{border: "none", background: "#f5f5f0"}}>
            //                     <AdviserPortalCharts advisers = {this.state.adviserSelected && this.state.adviserSelected.value === -1 ?
            //                         this.props.advisers : this.state.advisers}
            //                         total = {(this.state.adviserSelected === null || this.state.adviserSelected.value === -1) && this.props.total}
            //                         commissionPayments = {commissionPayments} />
            //                 </td>

            //             </tr>
            //         </tbody>

            //     </table>
            // </div>
            //Existing Code -end
        )
    }
}
export default withTranslation()(AdviserDashboard);

